import { handleRequest } from "../../axios";
import { axiosInstance } from "./JsdhNotifikaceService";
import {
    ADMIN_SPECIALIZACE_URL,
    ADMIN_SPECIALIZACE_BY_ID_URL,
    ADMIN_SPECIALIZACE_BULK_ASSIGN_URL,
} from "../url";
import type { Specializace } from "../generated/models/Specializace";
import type { SpecializaceRequest } from "../generated/models/SpecializaceRequest";
import type { BulkAssignSpecializaceRequest } from "../generated/models/BulkAssignSpecializaceRequest";

const getAllSpecializace = () => {
    return handleRequest<Specializace[]>(() =>
        axiosInstance.get(ADMIN_SPECIALIZACE_URL)
    );
};

const getSpecializaceById = (id: number) => {
    return handleRequest<Specializace>(() =>
        axiosInstance.get(ADMIN_SPECIALIZACE_BY_ID_URL(id))
    );
};

const createSpecializace = (data: SpecializaceRequest) => {
    return handleRequest<Specializace>(() =>
        axiosInstance.post(ADMIN_SPECIALIZACE_URL, data)
    );
};

const updateSpecializace = (id: number, data: SpecializaceRequest) => {
    return handleRequest<Specializace>(() =>
        axiosInstance.put(ADMIN_SPECIALIZACE_BY_ID_URL(id), data)
    );
};

const deleteSpecializace = (id: number) => {
    return handleRequest(() =>
        axiosInstance.delete(ADMIN_SPECIALIZACE_BY_ID_URL(id))
    );
};

const bulkAssignSpecializace = (data: BulkAssignSpecializaceRequest) => {
    return handleRequest<{ message: string }>(() =>
        axiosInstance.post(ADMIN_SPECIALIZACE_BULK_ASSIGN_URL, data)
    );
};

const SpecializaceServiceApi = {
    getAllSpecializace,
    getSpecializaceById,
    createSpecializace,
    updateSpecializace,
    deleteSpecializace,
    bulkAssignSpecializace,
};

export default SpecializaceServiceApi;
